import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification } from "antd";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { list } from "../../../controllers/V1/walletStatement/walletStatementController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import { usePermissions } from "../../../controllers/PermissionContext";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { formatProjectDate } from "../../../controllers/common";
const Export = ({ popUpOpen, togglePopUp, userData={} }) => {
  const PERMISSION = usePermissions("walletStatement");
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [todayDate, setTodayDate] = useState(moment().format('YYYY-MM-DD') || '');
  const [todayTime, setTodayTime] = useState('21:31:00');
  const [yesterdayDate, setYesterdayDate] = useState(`${moment().subtract(1,'days').format('YYYY-MM-DD')}`);
  const [yesterdayTime, setYesterdayTime] = useState('21:30:00');

  const handleDateTimeChange = (e)=>{
    const {name, value} = e.target;
    if(name === 'valid_date'){
      setYesterdayDate(value)
    } else if(name === 'valid_time'){
      setYesterdayTime(value)
    } else if(name === 'expire_date'){
      setTodayDate(value)
    } else if(name === 'expire_time'){
      setTodayTime(value)
    }
  }

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      if(!userData?.bind_person_id){
        notification.open({
          message: "Oops!",
          description: `Please select user.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }else{
        setIsLoading(true);
        const formData = new FormData(e.target);  
  
        const option = {
          isExport : true,
          condition: {
            ...(formData.get("order_no") && { 
              $or : [
                {order_id : formData.get("order_no")},
                {promocodeOrderNo : formData.get("order_no")},
                {product_order_no : formData.get("order_no")},
                {campaignOrderNo : formData.get("order_no")},
              ]  
          }),
            ...(formData.get("record_type") && {record_type: { $regex: formData.get("record_type"), $options: "i" }}),
            ...(formData.get("narration") && {narration: {$regex: formData.get("narration"),$options: "i",}}),
            $or : [
              {credit_user : userData?.bind_person_id},
              {debit_user : userData?.bind_person_id},
            ],
            createdAt : {$gte : `${yesterdayDate} ${yesterdayTime}`, $lte : `${todayDate} ${todayTime}`}
          }
        };
        // Make the API call
        const res = await list(option);
        if (res?.status === true && res?.result?.length > 0) {
          const transformedData = await Promise.all(res?.result.map((items) => {
            return {
              'Seq. ID'     : items.load_balance_id,
              'Narration'   : items.narration,
              ...(
                items?.narration === 'Lotto Winner Redeem' ||
                items?.narration === 'Campaign Commission' ||
                items?.narration === 'Campaign commission' ||
                items?.narration === 'Campaign Purchase' ||
                items?.narration === 'Campaign Purchase Cancel' ||
                items?.narration === 'Campaign Commission Reverse' 
              ) && ( {'Order No' : items?.campaignOrderNo}),
  
            ...((items?.narration === 'Product Order' || items?.narration === 'Product Cancel') && {'Order No' : items?.product_order_no}),
  
            ...(
              items?.narration === 'Voucher Commission' ||
              items?.narration === 'Voucher Purchase' ||
              items?.narration === 'Voucher Commission Reverse' ||
              items?.narration === 'Voucher Order Cancel'
            ) && ( {'Order No' : items?.promocodeOrderNo}),
  
            ...(items?.narration === 'Recharge' && {'Order No' : items?.credit_user?.users_mobile}),
            
            'Points' : items?.points?.toFixed(2),
            'Avl. Balance' : items?.availableArabianPoints.toFixed(2),
            'End Balance' : items?.end_balance.toFixed(2),
            'Created Date Time' : moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A'),
            'Record Type' : items?.record_type
            }
          }));
          exportToExcel(transformedData.reverse());
          handleCancel(); 
        } else {
          setIsLoading(false);
          notification.open({
            message: "Oops!",
            description: `No records found.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      // setError("An error occurred while exporting the data.");
      notification.open({
        message: "Oops!",
        description: `An error occurred while exporting the data.`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `wallet-statement_${moment().format('DD-MM-YYYY')}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Export Campaign Order
          </Typography>
          <Link
            to={false}
            style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }}
            onClick={handleCancel}
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="order_no"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Order No. :
                    </label>
                    <input
                      type="text"
                      name="order_no"
                      id="order_no"
                      placeholder="Order No."
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label
                      htmlFor="seller_first_name"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Record Type :
                    </label>
                    <select name="record_type" id="record_type" className="form-control categories_select_tg_enter_product" >
                      <option value="">All</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label
                      htmlFor="Narration"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Narration :
                    </label>
                    <input
                      type="text"
                      name="narration"
                      id="narration"
                      placeholder="Narration"
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label
                      for="select_title"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      {" "}
                      Date specific (If any) :
                    </label>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      From :
                    </label>
                    <input
                      type="date"
                      name="valid_date"
                      id="valid_date"
                      value={yesterdayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="valid_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="valid_time"
                      id="valid_time"
                      value={yesterdayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_date"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      To :
                    </label>
                    <input
                      type="date"
                      name="expire_date"
                      id="expire_date"
                      value={todayDate}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label
                      htmlFor="expire_time"
                      className="all_lable_for_vendor_dashbaord"
                    >
                      Time :
                    </label>
                    <input
                      type="time"
                      name="expire_time"
                      id="expire_time"
                      value={todayTime}
                      onChange={handleDateTimeChange}
                      className="form-control categories_select_tg_enter_product"
                    />
                  </div>

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button
                        type="button"
                        className="btn btn-light categories_cancel_button"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                        <button type="submit" className="btn btn-danger" disabled={isLoading} >
                          Download Excel
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: "red" }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default Export;
